function openPdf(res, filename = "report") {
  const blob = new Blob([res], { type: "application/pdf" });
  var blobURL = window.URL.createObjectURL(blob);
  // Create a temporary link to trigger the download
  var link = document.createElement("a");
  link.href = blobURL;
  link.download = filename; // Custom slug or filename
  // Open in a new tab
  window.open(blobURL, "_blank");
}

function downloadFile(res) {
  // const blob = new Blob([res]);

  // const link = document.createElement('a');
  // link.href = window.URL.createObjectURL(blob);
  // link.setAttribute('download', `Report.xlsx`);
  // link.click();
  const url = URL.createObjectURL(new Blob([res]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "report.xlsx");
  document.body.appendChild(link);
  link.click();
}

export { openPdf, downloadFile };
